import { Modal } from '@upright/ui/common/generic/components/modal/Modal';
import { Heading, Text } from '@upright/ui/common/generic/components/typography';
import { useHoldingsSourceDescription } from '@upright/ui/common/upright/model/input/attribution';
import { DATA_DISCLAIMER_TEXT } from '@upright/ui/common/upright/model/output/model-release-disclaimer';
import { getVersionAndRelease } from '@upright/ui/untidy/redux/selectors';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { groupfolioIdFromPath } from './company-profile-route';
import styles from './data-disclaimer-dialog.module.css';

/**
 * What the legacy views print as a static footer under every lens: the model release, the fund
 * holdings data source when the page is a fund or portfolio that has one, and the legal terms.
 * The unified shell opens it from Help instead (PLT-6866), so a view ends on its own data.
 *
 * The holdings source is read from the route because the top bar sits outside the page and
 * has no entity of its own.
 */
export function DataDisclaimerDialog(props: { isOpen: boolean; onClose: () => void }) {
  const { release } = useSelector(getVersionAndRelease);
  const { pathname } = useLocation();
  const holdingsSource = useHoldingsSourceDescription(groupfolioIdFromPath(pathname));
  return (
    <Modal isOpen={props.isOpen} onClose={props.onClose} aria-label="Data sources and disclaimer">
      <div className={styles.dialog}>
        <Heading level={2} size="xl" height="xl" weight="semibold">
          Data sources and disclaimer
        </Heading>
        <div className={styles.body}>
          {(release || holdingsSource) && (
            <div className={styles.sources}>
              {release && <Text>Results are based on Upright model release {release}.</Text>}
              {holdingsSource && <Text>{holdingsSource}.</Text>}
            </div>
          )}
          <Text size="sm" height="xs" color="gray-600">
            {DATA_DISCLAIMER_TEXT}
          </Text>
        </div>
      </div>
    </Modal>
  );
}
